// extracted by mini-css-extract-plugin
module.exports = {"CardRow":"styles_CardRow__2TNVW","Insured":"styles_Insured__3K6VY"};